import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0,
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    }
}));

const columns = [
    { id: 'id', label: 'id'},
    { id: 'data', label: 'Дата'},
    { id: 'login', label: 'Логин'},
    { id: 'amount', label: 'Сумма'},
    { id: 'payment_account', label: 'Платежный счет'},
    { id: 'pay', label: 'Платежная система'},
    { id: 'status', label: 'Статус'},
];

const getPayment = (val) => {
    switch (+val)  {
        case 1960:
        case 21013:
        case 21012:
        case 1963: return 'CARD';
        case 22351: return 'QIWI';
        case 101: return `LiteCoin`;
        case 102: return `Ethereum`;
        case 103: return `USDT-TRC20`;
        case 177: return `Piastrix`;

        default: return null
    }
}

const getRows = (replenishment) => {

    return replenishment.map((item) => {
        return {
            id: item.id,
            data: getDate(+item.data),
            login: item.login,
            amount: item.amount,
            payment_account: item.card_number,
            pay: getPayment(item.type),
            status: item.status,
        }
    })
}

export {
    useStyles,
    columns,
    getRows
}